<template>
  <div :class="[dataColumnClasses]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'GridColumnCmp',
  props: {
    dataColumnClasses: {
      type: String,
      default: 'col-12'
    }
  }
};
</script>